import moment from "moment";

const getSelectLocation = () => {
    const selectLocation = localStorage.getItem("selectLocation")
        ? JSON.parse(localStorage.getItem("selectLocation"))
        : null;
    return selectLocation;
};
const InitialState = {
    selectLocation: getSelectLocation(),
};

const SelectLocationReducer = (state = InitialState, action) => {
    if (action.type === "Select_Location") {
        const newState = {
            selectLocation: action.payload,
        };

        localStorage.setItem("selectLocation", JSON.stringify(action.payload));

        return newState;
    }

    //logout
    else if (action.type === "Remove_User") {
        const newState = {
            selectLocation: null,
        };

        localStorage.removeItem("selectLocation");
        return newState;
    }

    return state;
};

export default SelectLocationReducer;
